import Rx from 'rx';

export default function menu($location, UserService) {

  let trading, enterbo, ub;
  const sections = new Rx.BehaviorSubject([]);

  UserService.subject.subscribe(function (user) {
    trading = user.roles && user.roles.indexOf('trading') >= 0;
    enterbo = user.roles && user.roles.indexOf('enterbo') >= 0;
    ub = user.company_id.trim() === 'UB';

    updateMenu(user, trading);
  });

  function updateMenu(user, trading) {
    sections.onNext([
      {
        name: 'My Account',
        state: 'member.account',
        type: 'link'
      },
      {
        name: 'Trades',
        type: 'toggle',
        pastdue: user.pastdue,
        pastdue_message: 'Trading information is not available because your account is past due',
        disabled: user.pastdue || !trading,
        disabled_message: 'Call ECI to access trading: (800) 872-3324',
        pages: [
          {
            name: 'Current',
            type: 'link',
            state: "member.trades({report:'current'})",
            icon: 'fa fa-group',
            disabled: user.pastdue || !trading,
            pastdue: user.pastdue
          },
          {
            name: 'Previous',
            state: "member.trades({report:'report11'})",
            type: 'link',
            icon: 'fa fa-map-marker',
            disabled: user.pastdue || !trading,
            pastdue: user.pastdue
          },
          {
            name: 'Report 33',
            state: "member.trades({report:'report33'})",
            type: 'link',
            icon: 'fa fa-map-marker',
            disabled: user.pastdue || !trading,
            pastdue: user.pastdue,
            hidden: !ub,
          },
          {
            name: 'Weekly Summary',
            state: 'member.trades-weekly',
            type: 'link',
            icon: 'fa fa-plus',
            disabled: user.pastdue || !trading,
            pastdue: user.pastdue
          }]
      },
      {
        name: 'Bids/Offers',
        type: 'toggle',
        pastdue: user.pastdue,
        pastdue_message: 'Trading information is not available because your account is past due',
        disabled: user.pastdue || !trading,
        disabled_message: 'Call ECI to access trading: (800) 872-3324',
        pages: [
          {
            name: 'Current',
            type: 'link',
            state: "member.bids-offers({report:'current'})",
            icon: 'fa fa-group',
            disabled: user.pastdue || !trading,
            pastdue: user.pastdue
          },
          {
            name: 'Previous',
            state: "member.bids-offers({report:'report11'})",
            type: 'link',
            icon: 'fa fa-map-marker',
            disabled: user.pastdue || !trading,
            pastdue: user.pastdue
          },
          {
            name: 'New',
            state: "member.newbo",
            type: 'link',
            icon: 'fa fa-map-marker',
            disabled: user.pastdue || !trading,
            hidden: !enterbo,
            pastdue: user.pastdue
          }
        ]
      }]);
  }

  let self;

  return self = {
    sections: sections,

    toggleSelectSection: function (section) {
      self.openedSection = (self.openedSection === section ? null : section);
    },
    isSectionSelected: function (section) {
      return self.openedSection === section;
    },

    selectPage: function (section, page) {
      page && page.url && $location.path(page.url);
      self.currentSection = section;
      self.currentPage = page;
    }
  };
}
